'use client';
import {usePathname} from 'next/navigation';
import {IDatePickerDictonary} from '@/dictionaries/components/datePicker/types';
import {cn} from '@/lib/utils';

type Props = {
  dict: IDatePickerDictonary;
  className?: string;
  legendClassName?: string;
  showCalendarLegend?: boolean;
};

export default function Summary({
  dict,
  className,
  legendClassName,
  showCalendarLegend,
}: Props) {
  const pathname = usePathname();
  const {summary: summaryDict} = dict;
  const langs = ['de', 'it', 'fr'];

  function getContactLink() {
    const pathnameSplit = pathname.split('/');
    const possiblyForeignLanguage = pathnameSplit[1];
    if (langs.includes(possiblyForeignLanguage)) {
      return `/${possiblyForeignLanguage}/contacts`;
    }
    return '/contacts';
  }

  return (
    <div
      className={cn(
        'flex-[1_0_auto] order-1 text-center mr-0 bg-white mb-[50px] [@media(min-width:716px)]:flex-[1_0_200px] [@media(min-width:716px)]:mr-[5px] [@media(min-width:716px)]:mb-[0px] [@media(min-width:716px)]:mt-[50px] [@media(min-width:716px)]:break-normal desktop:!flex-[1_0_270px]',
        className,
        {
          'py-[85px] px-[30px]': showCalendarLegend,
          'pt-[20px] px-4 pb-0 [@media(min-width:716px)]:p-[30px]':
            !showCalendarLegend,
        },
      )}>
      <div className="[@media(min-width:716px)]:text-left">
        <span className="">{summaryDict.availabilityInformation}</span>
        <p className="text-sm leading-[1.6] font-extralight text-gray-700 mt-[10px] mb-[40px] [@media(min-width:716px)]:text-left">
          {summaryDict.description}{' '}
          {showCalendarLegend ? (
            <a
              onClick={() => {
                const enquiryForm = document.getElementById('enquiry-form');
                if (enquiryForm) {
                  enquiryForm.scrollIntoView({behavior: 'smooth'});
                }
              }}
              className="text-blue cursor-pointer">
              {summaryDict.sendEnquiry}
            </a>
          ) : (
            <a
              href={getContactLink()}
              target="_blank"
              className="text-blue cursor-pointer">
              {summaryDict.sendEnquiry}
            </a>
          )}
        </p>
        {showCalendarLegend && (
          <>
            <span className="[@media(min-width:716px)]:whitespace-nowrap">
              {summaryDict.calendarLegend}
            </span>
            <ul
              className={cn(
                'list-none flex justify-evenly mt-[10px] ml-[1.25rem] mb-4 list-outside [@media(min-width:716px)]:flex [@media(min-width:716px)]:flex-col [@media(min-width:716px)]:gap-4',
                legendClassName,
              )}>
              <li>
                <span className="text-gray-500 relative before:content-[''] before:absolute before:bottom-[-2px] before:left-[-10px] before:w-[calc(100%+20px)] before:h-[11px] before:rounded-[7px] before:bg-graphite before:opacity-[0.069]">
                  {summaryDict.notAvailable}
                </span>
              </li>
              <li>
                <span className="text-primary relative before:content-[''] before:absolute before:bottom-[-2px] before:left-[-10px] before:w-[calc(100%+20px)] before:h-[11px] before:rounded-[7px] before:bg-primary before:opacity-20">
                  {summaryDict.villageOptioned}
                </span>
              </li>
            </ul>
          </>
        )}
      </div>
    </div>
  );
}
